import React, { useState, Dispatch, SetStateAction } from 'react';

interface DeleteConfirmationModalContextInterface {
  modelLabel?: string;
  setModelLabel?: Dispatch<SetStateAction<string>>;
  deleteConfirmationModalOpen?: boolean;
  setDeleteConfirmationModalOpen?: Dispatch<SetStateAction<boolean>>;
  recordToDelete?: Record<string, any>;
  setRecordToDelete?: Dispatch<SetStateAction<Record<string, any>>>;
  deleteURL?: string;
  setDeleteURL?: Dispatch<SetStateAction<string>>;
  additionalParams?: object;
  setAdditionalParams?: Dispatch<SetStateAction<object>>;
}

interface DeleteConfirmationModalContextProviderProps {
  children: React.ReactNode;
}

const DeleteConfirmationModalContext = React.createContext<DeleteConfirmationModalContextInterface>({});

const DeleteConfirmationModalContextConsumer = DeleteConfirmationModalContext.Consumer;
const DeleteConfirmationModalContextProvider: React.FC<DeleteConfirmationModalContextProviderProps> = ({
  children,
}) => {
  let [additionalParams, setAdditionalParams] = useState<object>();
  let [modelLabel, setModelLabel] = useState<string>();
  let [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState<boolean>(false);
  let [recordToDelete, setRecordToDelete] = useState<Record<string, any>>();
  let [deleteURL, setDeleteURL] = useState<string>('');

  return (
    <DeleteConfirmationModalContext.Provider
      value={{
        additionalParams,
        setAdditionalParams,

        deleteURL,
        setDeleteURL,

        modelLabel,
        setModelLabel,

        deleteConfirmationModalOpen,
        setDeleteConfirmationModalOpen,

        recordToDelete,
        setRecordToDelete,
      }}
    >
      {children}
    </DeleteConfirmationModalContext.Provider>
  );
};

export {
  DeleteConfirmationModalContextProvider,
  DeleteConfirmationModalContextConsumer,
  DeleteConfirmationModalContext,
};
